import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { deleteAllUserData } from "../../../../app/store/slices/userSlice";
import ConfirmationModal from "../../../shared/components/modals/ConfirmationModal";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const DeleteData = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  const storedData = JSON.parse(localStorage.getItem("authData"));
  const userId = storedData?.user?._id;

  const handleDelete = async () => {
    setIsDeleting(true);
    try {
      await dispatch(deleteAllUserData(userId)).unwrap();
      setShowModal(false);
      toast.success("All your data has been successfully deleted.");
      localStorage.removeItem("authData");
      setTimeout(() => {
        navigate("/login");
        window.location.reload();
      }, 1500);
    } catch (error) {
      toast.error(
        error?.message || "Failed to delete your data. Please try again."
      );
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto bg-white rounded-xl shadow p-8 mt-10">
      <h1 className="text-2xl font-bold text-btn-primary mb-4 text-center">
        Delete All Your Data
      </h1>
      <p className="text-gray-700 mb-6 text-center">
        This action will permanently delete <b>all</b> your data from Cash Canvas,
        including your account, transactions, budgets, and settings. This cannot be
        undone.
      </p>
      <div className="flex justify-center">
        <button
          onClick={() => setShowModal(true)}
          className="px-6 py-2 rounded-full bg-red-600 text-white font-semibold shadow hover:bg-red-700 transition"
        >
          Delete
        </button>
      </div>
      <ConfirmationModal
        show={showModal}
        title="Delete All Data"
        message="Are you sure you want to permanently delete all your data? This action cannot be undone."
        onCancel={() => setShowModal(false)}
        onConfirm={handleDelete}
        confirmText="Delete"
        cancelText="Cancel"
        loading={isDeleting}
      />
    </div>
  );
};

export default DeleteData;